var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane fade show active"},[(!_vm.is_data_ready)?_c('div',{staticClass:"tab-pane fade show active text-center"},[_c('span',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"data-crowdynews-widget":'imediamatch_team-' + _vm.team_slug}}),_vm._v("\n    "+_vm._s(_vm.error_msg)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }